/**
 * PilotTopMask component.
 */
import Mask from '@shared/assets/images/png/pilotTopMask.png';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled pilot top mask.
 */
const PilotTopMask = styled.img<React.CSSProperties>`
  height: ${387 * Screen.widthRatio}px;
  opacity: ${(props) => props.opacity || 1};
  overflow: hidden;
  // position: absolute;
  width: 100%;
  z-index: 1;
`;

PilotTopMask.defaultProps = {
  src: Mask,
};

export default withImage(PilotTopMask, false);
